import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useDebouncedCallback} from 'use-debounce';
import {isSlideModifiedSelector, selectedSlideSelector} from '../../../store/selectors/slide.selectors';
import useSaveSlide from './useSaveSlide';
import {loggedInUserSelector} from '../../../store/selectors/auth.selectors';
import {useSlidePreview} from './useSlidePreview';

export function useOnSlideModified(): {cancelAutosave: () => void} {
    const dispatch = useDispatch();
    const user = useSelector(loggedInUserSelector);
    const slide = useSelector(selectedSlideSelector);
    const modified = useSelector(isSlideModifiedSelector);
    const slideMutation = useSaveSlide({omitToastMessage: true});
    const mutateSlideDebounced = useDebouncedCallback(slideMutation.mutate, 5000);
    const {updateSlidePreview} = useSlidePreview();

    useEffect(() => {
        if (modified) {
            updateSlidePreview();
        }
        if (modified && user?.autoSave) {
            mutateSlideDebounced({slide});
        }
    }, [dispatch, modified, mutateSlideDebounced, updateSlidePreview, slide, user?.autoSave]);

    return {cancelAutosave: mutateSlideDebounced.cancel};
}
